import { animate, animation, style } from '@angular/animations';

import { DEFAULT_TIMING } from '../ng-animate/utils';

const COLLAPSED = { padding: '0px', height: '0px', minHeight: '0', visibility: 'hidden', opacity: 0 };
const EXPANDED = { padding: '*', height: '*', visibility: 'visible', opacity: 1 };
const DEFAULT_PARAMS = { timing: DEFAULT_TIMING, delay: 0, timingFn: 'cubic-bezier(0.4, 0.0, 0.2, 1)' };

export const expand = animation(
  [style(COLLAPSED), animate('{{ timing }}s {{ delay }}s {{ timingFn }}', style(EXPANDED))],
  { params: DEFAULT_PARAMS }
);

export const collapse = animation(
  [style(EXPANDED), animate('{{ timing }}s {{ delay }}s {{ timingFn }}', style(COLLAPSED))],
  { params: DEFAULT_PARAMS }
);
